import { Autocomplete, OutlinedInput } from '@mui/material';
import { useJsonAPI } from 'json-api-hooks';
import React, { useMemo } from 'react';

import toString from '../../../lib/toString';
import useAsyncFieldOptions from '../hooks/useAsyncFieldOptions';
import { InputRenderer } from '../types';

const SearchInput = ({ fieldState, inputProps, placeholder, resource, resourceType }: InputRenderer) => {
  const { router, store } = useJsonAPI();
  const [inputValue, setInputValue] = React.useState('');
  const { options } = useAsyncFieldOptions(resource, resourceType!, inputValue);
  const stringOptions = useMemo(() => options.map((option) => option.key), [options]);

  return (
    <>
      <Autocomplete<string>
        autoComplete
        disablePortal
        filterSelectedOptions
        fullWidth
        filterOptions={(x) => x}
        getOptionLabel={(id) =>
          id ? toString(store.getResource(router.resourceRoute({ id, type: resourceType! }))) : ''
        }
        id={inputProps.name}
        loadingText="Laden..."
        noOptionsText={inputValue ? 'Geen opties beschikbaar' : 'Typ om te zoeken'}
        options={stringOptions}
        renderInput={(params) => (
          <OutlinedInput error={fieldState?.invalid} placeholder={placeholder} {...params} {...params.InputProps} />
        )}
        value={inputProps.value ?? ''}
        onChange={(_event, newValue) => {
          inputProps.onChange(newValue);
        }}
        onInputChange={(_event, newInputValue) => {
          setInputValue(newInputValue);
        }}
      />
    </>
  );
};

export default SearchInput;
